module.exports = __webpack_public_path__ + "media/pt_pt_s4_Miciela.3f236f1b.mp3";